import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { DialogWithForm } from '@strata/react-dialog';
import { TextAreaFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { filterListItems, ListType, validateNpis } from 'services/ListManagementHelpers';

export const PrescriberBulkDeleteDialog = ({ isOpen, onClose }) => {
    const listFormik = useFormikContext();
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validationSchema={Yup.object({
                npis: Yup.string().required(validationStrings.requiredField.errorMessage),
            })}
            onSubmit={async (values, { resetForm }) => {
                const npisToDelete = validateNpis(values);
                if (npisToDelete) {
                    const prescribersToDelete = npisToDelete
                        .map((npi) =>
                            listFormik.values.listItems.find(
                                (prescriber) => prescriber.prescriber_npi === npi,
                            ),
                        )
                        .filter((prescriber) => prescriber != null);

                    await listFormik.setValues({
                        ...listFormik.values,
                        listItems: filterListItems(
                            listFormik.values.listItems,
                            prescribersToDelete,
                            ListType.prescriber,
                        ),
                        addedItems: filterListItems(
                            listFormik.values.addedItems,
                            prescribersToDelete,
                            ListType.prescriber,
                        ),
                        deletedItems: [
                            ...listFormik.values.deletedItems,
                            ...filterListItems(
                                prescribersToDelete,
                                listFormik.values.deletedItems,
                                ListType.prescriber,
                            ),
                        ],
                        selected: [],
                        itemsToDelete: [],
                    });

                    SuccessToast({ message: 'Prescribers deleted successfully.' });
                    resetForm();
                    onClose();
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle="Confirm Bulk Delete Prescribers"
                    headerIcon={IconNames.WARNING_SIGN}
                    primaryButtonLabel="Bulk Delete Prescribers"
                    primaryButtonIntent={Button.Intent.DANGER}
                    secondaryButtonLabel="Cancel"
                    width={560}
                    isOpen={isOpen}
                    onSecondaryButtonClick={(e) => {
                        formik.handleReset(e);
                        onClose();
                    }}
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    right
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                Delete prescribers by entering their NPI below.
                            </div>
                            <TextAreaFormik
                                id="npis"
                                label="NPI"
                                required
                                helperText="Separate multiple NPI numbers using a comma (e.g., 0000000000,1111111111) or insert one NPI number per line."
                            />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

PrescriberBulkDeleteDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
